import { styled, Box, Button, ListItem } from '../../../base';

export const MenuWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%', // Fill the parent LeftSidemenu container
});

export const AddJobButtonStyled = styled(Button)(({ theme }) => ({
    margin: theme.spacing(0, 0, 1, 0), // Reduced top margin
    color: theme.palette.common.white,
}));

export const LinksListScrollableContainer = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    overflowY: 'auto',
    paddingInlineEnd: theme.spacing(0.5), // Space for scrollbar to avoid content overlap
    marginInlineEnd: theme.spacing(-0.5), // Counteract padding for alignment if needed
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor:
            theme.palette.mode === 'dark'
                ? theme.palette.grey[700]
                : theme.palette.grey[400],
        borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor:
            theme.palette.mode === 'dark'
                ? theme.palette.grey[600]
                : theme.palette.grey[500],
    },
}));

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
        // Remove border from the last item
        borderBottom: 'none',
    },
}));

export const UserPreviewWrapper = styled(Box)(({ theme }) => ({
    marginTop: 'auto', // Pushes it to the bottom of the flex container
    paddingTop: theme.spacing(1), // Some spacing above the user preview. theme.spacing(1) = 8px
    // borderTop: `1px solid ${theme.palette.divider}`, // Optional: if a separator is desired
}));
